import type { TranslationModule } from '../types';
import { ecrisTranslations } from './ecris';

export const settingsTranslations: TranslationModule = {
  ro: {
    page: {
      titleAdmin: "Configurare Sistem",
      titleUser: "Contul Meu",
      subtitleAdmin: "Ajustează parametrii și gestionează utilizatorii",
      subtitleUser: "Gestionează setările contului și abonamentul",
      backToHome: "Pagina Principală",
      back: "Înapoi",
      resetBtn: "Resetează",
      resetConfirm: "Sigur dorești să resetezi toate setările la valorile implicite?",
      resetSuccess: "Setările au fost resetate la valorile implicite.",
      resetError: "Eroare la resetarea setărilor.",
      exportMenuBtn: "Descarcă Meniu XL",
      exportMenuProgress: "Se exportă...",
      exportMenuSuccess: "Meniul a fost exportat cu succes!",
      exportMenuError: "Eroare la exportul meniului.",
      refreshFiltersBtn: "Reîncarcă Filtre",
      refreshFiltersProgress: "Se reîncarcă...",
      refreshFiltersConfirm: "Sigur dorești să reîncarci toate filtrele? Acest proces poate dura câteva secunde.",
      refreshFiltersSuccess: "Filtrele au fost reîncărcate cu succes! Gruparea obiectelor juridice a fost actualizată.",
      refreshFiltersError: "Eroare la reîncărcarea filtrelor. Verifică conexiunea la server.",
      saveBtn: "Salvează",
      saveProgress: "Se salvează...",
      saveSuccess: "Setările au fost salvate cu succes!",
      saveError: "Eroare la salvarea setărilor.",
      loadSettingsError: "Nu s-au putut încărca setările. Verifică conexiunea la server.",
      tabProfile: "Profil",
      tabCompanies: "Firmele mele",
      tabAddresses: "Adresele mele",
      tabStorage: "Stocare Date & Cloud",
      tabSubscription: "Abonament & Plăți",
      tabUsers: "Utilizatori",
      tabImportCase: "📥 Import Speță",
      tabImportCaseBulk: "📚 Import Bulk Spețe",
      tabVideoPresentation: "🎥 Video Prezentare",
      tabRvcVoices: "🎙️ Voci RVC",
      tabCollaborators: "Trimite Email Colaboratori",
      selectSection: "Selectează secțiunea",
      currentSection: "Secțiune activă",
      changeSection: "Schimbă",
      closeSectionMenu: "Închide"
    },
    users: {
      title: "CRM / Utilizatori",
      totalRegistered: "Total înregistrați: {count}",
      searchPlaceholder: "Caută după nume, email, CUI...",
      searchAriaLabel: "Caută după nume, email sau CUI",
      clearSearch: "Șterge căutarea",
      globalActions: "Acțiuni globale",
      enableAiNavAll: "Activează Navigare AI (toți)",
      disableAiNavAll: "Dezactivează Navigare AI (toți)",
      tableScrollHint: "Derulează orizontal pentru mai multe coloane",
      tableScrollKeyboardHint: "Tastează săgețile stânga/dreapta pentru navigare",
      tableAriaLabel: "Tabel utilizatori CRM",
      colUser: "Utilizator",
      colStatusContact: "Stare & Contact",
      colDoctrineEditor: "Acces Doctrină & Editor",
      colVoiceVideo: "Voce AI / Video",
      colAiNav: "Navigare AI & Profesionist",
      colCost: "Cost AI",
      colRole: "Acces & Rol",
      colRegistration: "Înregistrare",
      colActions: "Acțiuni",
      noPhone: "Fără telefon",
      doctrineAccess: "Acces Doctrină",
      doctrineActive: "Activat",
      doctrineInactive: "Inactiv",
      editorAccess: "Acces Editor",
      editorActive: "Editor Activat",
      editorInactive: "Fără acces Editor",
      voiceAndreea: "Voce Andreea",
      voiceStandard: "Standard",
      wav2lipVideo: "Generare video Wav2Lip",
      aiNav: "Navigare AI",
      aiNavActive: "Navigare AI Activă",
      aiNavManual: "Mod Manual",
      proMode: "Profesionist",
      proModeActive: "Profesionist",
      proModeInactive: "Neprofesionist",
      perMonth: "/ lună",
      totalCalls: "{count} apeluri / lună",
      viewDetails: "Vezi detalii complete",
      deleteUser: "Șterge utilizator",
      cardDetailsBtn: "Detalii și administrare",
      cardCollapseBtn: "Mai puține detalii",
      sectionContact: "Contact & Date Fiscale",
      sectionPermissions: "Permisiuni & Acces",
      sectionAiCosts: "Costuri & Consum AI",
      sectionAdministration: "Administrare Cont",
      registeredOn: "Înregistrat:",
      openFullFile: "Deschide fișa completă",
      deleteAccount: "Șterge contul definitiv",
      pageOf: "Pagina {page} din {total}",
      pricingTitle: "Contabilitate Costuri AI & Configurare Tarife",
      refreshData: "Actualizează date",
      savePricing: "Salvează tarife",
      inputPriceLabel: "Input / 1M tokeni (USD)",
      outputPriceLabel: "Output / 1M tokeni (USD)",
      cachedInputPriceLabel: "Cached input / 1M (USD)",
      adjustCachedPrice: "+ Ajustează Cached input",
      pricingNote: "* Tarifele modificate se aplică exclusiv apelurilor viitoare. Istoricul ledger rămâne imutabil la tariful din momentul execuției.",
      lastUpdated: "Ultima actualizare: {date} de {user}",
      bulkConfirmTitleEnable: "Confirmare activare Navigare AI în masă",
      bulkConfirmTitleDisable: "Confirmare dezactivare Navigare AI în masă",
      bulkConfirmCancel: "Anulează",
      bulkConfirmBtn: "Confirmă operațiunea"
    },
    profile: {
      title: "Informații Profil",
      avatarFallback: "Utilizator",
      roleAdmin: "Administrator",
      rolePro: "Utilizator Pro",
      roleBasic: "Utilizator Basic",
      emailLabel: "Email",
      authMethodLabel: "Metodă Autentificare",
      authGoogle: "Conectat cu Google",
      authPassword: "Email și Parolă",
      registrationDateLabel: "Data Înregistrării",
      mobileAccessTitle: "Acces Aplicație Mobilă (Google Play)",
      mobileAccessDesc: "Pentru a te putea conecta în aplicația mobilă (versiunea din Google Play), trebuie să îți setezi o parolă. Vei folosi adresa ta de email curentă ({email}) împreună cu această parolă. Accesul prin Google pe platforma web va funcționa în continuare normal.",
      setPasswordLabel: "Setează o parolă pentru aplicația mobilă",
      passwordMinLength: "Minim 8 caractere, cu litere și cifre",
      passwordRequiredError: "Te rugăm să introduci o parolă.",
      passwordMinLengthError: "Parola trebuie să conțină minimum 8 caractere.",
      passwordSuccess: "Parola a fost setată cu succes. Te poți conecta acum în aplicația mobilă.",
      savePasswordBtn: "Salvează Parola",
      deleteAccountBtn: "Șterge Contul",
      deleteAccountProgress: "Se șterge...",
      deleteAccountError: "Nu s-a putut șterge contul.",
      deleteAccountGenericError: "A apărut o eroare la ștergerea contului. Te rugăm să încerci din nou.",
      unsubscribeBtn: "Dezabonează-te",
      logoutBtn: "Deconectare",
      deleteModalTitle: "Ștergere Cont",
      deleteModalMessage: "Ești sigur că vrei să ștergi contul? Această acțiune este ireversibilă și toate datele tale vor fi pierdute.",
      deleteModalConfirm: "Șterge Contul",
      deleteModalCancel: "Anulează"
    },
    company: {
      title: "Firmele mele",
      subtitle: "Adaugă aici datele companiilor tale pentru a le folosi pe facturi.",
      addBtn: "Adauga companie",
      loadError: "Nu s-au putut încărca companiile.",
      deleteError: "A apărut o eroare la ștergerea companiei: {message}",
      noCompaniesTitle: "Nu ai adăugat nicio firmă",
      noCompaniesDesc: "Cumperi pentru firma ta? Nicio problemă! Adaugă aici datele care vor apărea pe factura comenzii tale.",
      cardDeleteTitle: "Sterge firma",
      cardDeleteConfirmMsg: "Esti sigur ca vrei sa stergi aceasta companie?",
      cardDeleteConfirmBtn: "Sterge",
      cardDeleteCancelBtn: "Anuleaza",
      modalTitle: "Adauga persoana juridica",
      modalSecDetails: "Detalii companie",
      modalSecAddress: "Sediu social",
      modalNameLabel: "Nume firma",
      modalNamePlaceholder: "ex: Cabinet Avocatura Ionescu",
      modalCuiLabel: "Cod Unic de Inregistrare",
      modalCuiPlaceholder: "12345678",
      modalRegComLabel: "Numar de inregistrare in Registrul Comertului",
      modalBancaLabel: "Banca",
      modalBancaPlaceholder: "ex: Banca Transilvania",
      modalIbanLabel: "Cont IBAN",
      modalIbanPlaceholder: "RO12 BTRL ...",
      modalCountyLabel: "Județ",
      modalCountyPlaceholder: "Caută județul...",
      modalLocalityLabel: "Localitate",
      modalLocalityPlaceholder: "ex: Sector 1",
      modalAddressLabel: "Adresa",
      modalAddressPlaceholder: "ex: Strada, numar, bloc, scara, etaj, apartament",
      modalSaveBtn: "Salveaza",
      modalSaveProgress: "Se salveaza...",
      valNameRequired: "Numele firmei este obligatoriu.",
      valCuiInvalid: "Codul Unic de Înregistrare (CUI) nu este valid.",
      valIbanInvalid: "Codul IBAN nu este valid. Verificați formatul RO...",
      valCountyRequired: "Județul este obligatoriu.",
      valYearInvalid: "Anul înregistrării nu este valid.",
      valRegComInvalid: "Numărul de ordine în Registrul Comerțului nu este valid.",
      valSaveError: "A aparut o eroare la salvarea firmei."
    },
    address: {
      title: "Adresele mele",
      subtitle: "Gestionează adresele de livrare și facturare.",
      addBtn: "Adauga adresa",
      loadError: "Nu s-au putut încărca adresele.",
      deleteError: "A apărut o eroare la ștergerea adresei.",
      noAddressesTitle: "Nu ai adăugat nicio adresă",
      noAddressesDesc: "Salvează aici adresele tale pentru a plasa comenzi mai rapid.",
      cardEditBtn: "editează",
      cardDeleteBtn: "șterge",
      cardDeleteConfirm: "Sigur dorești să ștergi această adresă?",
      modalTitleEdit: "Modifică adresa",
      modalTitleAdd: "Adaugă adresă",
      modalSecContact: "Persoana de contact",
      modalSecAddress: "Adresa de livrare",
      modalNameLabel: "Nume",
      modalNamePlaceholder: "Nume Prenume",
      modalPhoneLabel: "Număr de telefon",
      modalPhonePlaceholder: "07xxxxxxxx",
      modalCountyLabel: "JUDEȚ",
      modalCountyPlaceholder: "Caută județul...",
      modalLocalityLabel: "Localitate",
      modalLocalityPlaceholder: "Ex: Sector 1",
      modalAddressLabel: "Adresa",
      modalAddressPlaceholder: "Strada, Număr, Bloc, Scara etc.",
      modalSaveBtn: "Salvează",
      valPhoneInvalid: "Numărul de telefon nu este valid. Folosiți formatul 07xxxxxxxx.",
      valSaveError: "A apărut o eroare la salvarea adresei."
    },
    storage: {
      secBanner: "🔐 Securitate Militară și Descentralizare",
      title: "Stocare Descentralizată & Confidențialitate Absolută",
      desc: "Prin activarea integrării contului tău Google Drive, dosarele, contactele și documentele sunt stocate în mod privat în cloud-ul tău personal.",
      descHighlight: "Verdict Line / LegeaAplicată are ZERO acces la datele, documentele sau dosarele tale!",
      successDriveConnected: "Contul Google Drive a fost conectat cu succes!",
      errorDriveFailed: "Conectarea Google Drive a eșuat.",
      successDriveDisconnected: "Contul Google Drive a fost deconectat.",
      errorConnectFirst: "Te rugăm să te conectezi mai întâi la Google Drive.",
      successMigration: "Datele tale au fost migrate cu succes pe Google Drive-ul tău securizat!",
      errorMigrationFailed: "Migrarea a eșuat.",
      errorConfirmWord: "Pentru resetare, te rugăm să tastezi exact 'CONFIRM' în căsuța de validare.",
      successReset: "Modul de stocare a fost resetat înapoi la Server.",
      errorResetFailed: "Resetarea a eșuat.",
      secTitleSelect: "Selectează Modul de Stocare Date",
      serverTitle: "Server Securizat",
      serverStatusActive: "Activ",
      serverDesc: "Datele tale din CRM sunt salvate pe serverele centrale securizate Verdict Line. Oferă acces rapid și sincronizare automată multi-utilizator pre-configurată.",
      driveTitle: "Google Drive Personal",
      driveStatusActive: "Privativ Activ",
      driveDesc: "Datele sunt descentralizate complet în mod automat. Doar dumneavoastră dețineți controlul fizic, fișierele și spațiul de stocare, fiind ideal pentru standarde riguroase de secret profesional.",
      serverActionTitle: "Ești gata să treci la Stocarea Descentralizată pe Google Drive?",
      serverActionDesc: "Această acțiune va iniția o migrare securizată care va copia dosarele, structurile juridice și clienții în folderul privat Google Drive, securizând totul la cel mai înalt nivel. Baza ta de date centralizată de pe server va fi dezafectată în siguranță.",
      connectGoogleBtn: "Conectează contul Google",
      disconnectGoogleBtn: "Deconectare Cont",
      storageLabel: "Spațiu stocare Google Drive:",
      storageUsage: "{percent}% utilizat ({usage} / {limit})",
      migrateBtn: "Inițiază Migrare pe Google Drive",
      migratingBtn: "Se migrează datele...",
      migrationProgressTitle: "Procesare migrare securizată...",
      migrationStatusPreparing: "Pregătire migrare...",
      driveActiveTitle: "Stocarea pe Google Drive-ul tău este Activă & Securizată",
      driveActiveDesc: "Datele tale din CRM și Dosare sunt salvate privat sub format de documente criptate securizat în directorul rădăcină: Google Drive/LegeaAplicata_CRM. Sincronizarea are loc local direct din browser-ul tău. Serverul Verdict Line are acces ZERO la aceste date.",
      driveActiveWarning: "Butonul simplu de comutare a fost blocat în mod securizat pentru a evita distrugerea datelor sau crearea de bucle care ar bloca conexiunea. Dacă dorești cu orice preț revenirea la Server, folosește zona de dedesubt.",
      showDangerZone: "Afișează Zona de Administrare Avansată (Revenire Server)",
      dangerZoneTitle: "Zonă Periculoasă: Resetare la Stocare Server",
      dangerZoneDesc: "Atenție! Comutarea înapoi la server se face fără migrarea automată a datelor pentru a preveni coliziunea fișierelor și coruperea lor. Datele introduse în Google Drive în acest timp vor rămâne pe Drive, dar contul tău se va conecta din nou la datele înghețate sau goale de pe server.",
      dangerZoneConfirmLabel: "Pentru validare, tastează exact cuvântul CONFIRM:",
      dangerZoneBtn: "Resetează stocarea la modul Server",
      dangerZoneProgressBtn: "Se resetează stocarea...",
      dangerZoneCancelBtn: "Anulează",
      benefitsTitle: "Beneficiile Integrării Directe cu Ecosistemul Google",
      benefitsDesc: "Interfața inteligentă se conectează direct din browser la contul tău personal sau profesional de Google, oferindu-ți libertate și protecție totală.",
      benefit1Title: "Descentralizare Totală (Google Drive)",
      benefit1Desc: "Datele nu părăsesc ecosistemul tău. Sunt stocate sub forma unor fișiere JSON securizate în propriul tău Google Drive. Dacă îți retragi permisiunea, ai control deplin și fizic asupra întregii arhive.",
      benefit2Title: "Sincronizare Google Calendar",
      benefit2Desc: "Fiecare termen de judecată monitorizat, calculat conform Codului de Procedură Civilă sau adăugat manual, se trimite instantaneu în Google Calendar. Ai mementouri și alerte pe telefon în timp real.",
      benefit3Title: "Securitate OAuth 2.0",
      benefit3Desc: "Integrarea respectă standardul oficial Google Identity. Parolele tale nu ajung niciodată la noi. Conexiunea se realizează printr-un token de acces stocat local și criptat în siguranță în browser-ul tău.",
      guideTitle: "Cum se Configurează Integrarea Google?",
      guideDesc: "Procesul este simplu, extrem de transparent și durează sub 2 minute. Iată pașii exacți pe care trebuie să îi urmezi:",
      guide1Title: "Accesează panoul de Setări Stocare",
      guide1Desc: "Intră în contul tău de editor sau administrator în secțiunea Stocare Date & Cloud. Aici vei găsi panoul oficial de control API.",
      guide2Title: "Autentifică-te prin Google Identity",
      guide2Desc: "Apasă pe butonul „Conectează contul Google”, selectează contul preferat de Google sau Gmail în fereastra oficială deschisă și validează acordarea permisiunilor de acces.",
      guide3Title: "Activarea Google API (Important pentru primii pași)",
      guide3Desc: "Asigură-te că Google Drive API și Google Calendar API sunt activate în consola ta Google Cloud. În caz de eroare 403 API disabled, urmează instrucțiunile și butoanele de mai jos pentru activarea directă în consolă:",
      guide4Title: "Sincronizare Automată Activată!",
      guide4Desc: "Gata! Aplicația creează automat directorul privat LegeaAplicataCRM pe Drive. Toate dosarele și acțiunile CRM sunt sincronizate în tempo real fără interfețe terțe.",
      faqTitle: "Întrebări Frecvente (FAQ)",
      faqDesc: "Tot ce trebuie să știi despre stocarea datelor și sincronizarea securizată cu Google.",
      faqQ1: "Cine are acces fizic la dosarele mele stocate în Google Drive?",
      faqA1: "Doar dumneavoastră și persoanele pe care le autorizați în interiorul CRM-ului (editori, administratori). Conexiunea dintre browser-ul dumneavoastră și serverul Google API se face direct, folosind credențialele dumneavoastră, fără ca baza de date să treacă sau să fie stocată vreodată pe serverul central LegeaAplicată.",
      faqQ2: "Este necesar să plătesc un abonament Google suplimentar?",
      faqA2: "Nu. Serviciul folosește spațiul oferit gratuit de Google la crearea oricărui cont de Gmail standard (15 GB). Dosarele stocate sub format structurat ocupă un spațiu extrem de mic (sub câțiva megabytes pentru mii de dosare), deci nu veți avea nevoie niciodată de upgrade la spațiu special.",
      faqQ3: "Ce se întâmplă dacă îmi pierd statutul de Editor sau Admin în LegeaAplicată?",
      faqA3: "Pentru a garanta securitatea absolută a datelor cabinetului dumneavoastră, accesul la stocarea Google Drive și conexiunile API este permis exclusiv conturilor de tip Administrator sau Editor. În secunda în care dreptul dumneavoastră este retras de către proprietarul contului, accesul este blocat instantaneu.",
      faqQ4: "Pot să folosesc sincronizarea cu calendarul de pe telefon?",
      faqA4: "Da, absolut! Pentru că termenele sunt salvate în Google Calendar-ul asociat contului dumneavoastră, acestea vor apărea automat pe aplicația nativă Google Calendar din iOS (iPhone), iPad sau orice dispozitiv Android, fiind însoțite de alerte sonore și notificări."
    },
    subscription: {
      title: "Status Abonament",
      desc: "Informații despre planul tău curent.",
      errorPlansLoad: "Nu s-au putut încărca planurile.",
      errorCheckoutInit: "Eroare la inițierea plății.",
      errorCheckoutSession: "Nu s-a putut genera sesiunea de plată.",
      errorCancelSub: "Nu s-a putut anula abonamentul.",
      errorCancelSubGeneric: "A apărut o eroare la anularea abonamentului.",
      errorOpenPortal: "Nu s-a putut deschide portalul.",
      warningPastDueTitle: "Plata a eșuat sau este întârziată.",
      warningPastDueDesc: "Accesul tău Premium este în pericol. Te rugăm să actualizezi metoda de plată pentru a evita suspendarea serviciului.",
      warningPastDueBtn: "Actualizează Cardul Acum",
      warningUnpaidTitle: "Abonament Suspendat.",
      warningUnpaidDesc: "Nu am putut procesa plata pentru abonamentul tău. Beneficiile Premium sunt momentan inactive.",
      warningUnpaidBtn: "Rezolvă Problema de Plată",
      successCancel: "Abonamentul a fost anulat cu succes. Accesul rămâne activ până la expirare.",
      backBtn: "Înapoi",
      checkoutTitle: "Finalizare Plată - {planName}",
      plansBackBtn: "Înapoi la Profil",
      plansTitle: "Alege Planul Premium",
      planPopularBadge: "POPULAR",
      statusLoading: "Se încarcă statusul...",
      statusPlanType: "Tip Abonament",
      statusCostLabel: "Cost Lunar",
      statusActiveDate: "Dată Activare",
      statusNextPayment: "Următoarea Plată",
      statusExpirationDate: "Expiră La",
      statusUnlimited: "Nelimitat",
      statusPaymentMethod: "Metodă de plată: ",
      statusPaymentManual: "manual_grant",
      statusPaymentLegacy: "Migrare Platformă Veche",
      infoTitleUpgrade: "Treci la Premium?",
      infoTitleActive: "Status Abonament",
      infoDescUpgrade: "Obține acces nelimitat, analiză AI avansată și suport prioritar.",
      infoDescActive: "Beneficiezi de toate funcționalitățile PRO active.",
      infoDescStatus: "Verifică statusul abonamentului tău.",
      btnViewPlans: "Vezi Planurile Premium",
      btnManagePortal: "Gestionare Abonament & Plăți (Stripe)",
      statusActiveBadge: "Abonament Activ",
      btnUnsubscribe: "Dezabonează-te",
      unsubscribeHint: "Poți anula oricând din cont sau din Portalul Stripe.",
      scheduledCancelTitle: "Anulare Programată",
      scheduledCancelDesc: "Acces valid până la {date}",
      footerSecurePay: "Plată Securizată Stripe",
      modalCancelTitle: "Ești sigur că vrei să anulezi abonamentul?",
      modalCancelMessage: "Vei pierde accesul la beneficiile Premium la finalul perioadei curente. Această acțiune este ireversibilă după expirarea perioadei.",
      modalCancelConfirm: "Da, Anulează Abonamentul",
      modalCancelCancel: "Nu, Păstrează Abonamentul"
    },
    ecris: ecrisTranslations.ro
  },
  en: {
    page: {
      titleAdmin: "System Configuration",
      titleUser: "My Account",
      subtitleAdmin: "Adjust parameters and manage users",
      subtitleUser: "Manage account settings and subscription",
      backToHome: "Home Page",
      back: "Back",
      resetBtn: "Reset",
      resetConfirm: "Are you sure you want to reset all settings to default values?",
      resetSuccess: "Settings have been reset to default values.",
      resetError: "Error resetting settings.",
      exportMenuBtn: "Download XL Menu",
      exportMenuProgress: "Exporting...",
      exportMenuSuccess: "The menu was successfully exported!",
      exportMenuError: "Error exporting menu.",
      refreshFiltersBtn: "Reload Filters",
      refreshFiltersProgress: "Reloading...",
      refreshFiltersConfirm: "Are you sure you want to reload all filters? This process may take a few seconds.",
      refreshFiltersSuccess: "Filters successfully reloaded! The legal objects grouping has been updated.",
      refreshFiltersError: "Error reloading filters. Check server connection.",
      saveBtn: "Save",
      saveProgress: "Saving...",
      saveSuccess: "Settings have been successfully saved!",
      saveError: "Error saving settings.",
      loadSettingsError: "Could not load settings. Check server connection.",
      tabProfile: "Profile",
      tabCompanies: "My Companies",
      tabAddresses: "My Addresses",
      tabStorage: "Data Storage & Cloud",
      tabSubscription: "Subscription & Payments",
      tabUsers: "Users",
      tabImportCase: "📥 Import Case",
      tabImportCaseBulk: "📚 Import Bulk Cases",
      tabVideoPresentation: "🎥 Video Presentation",
      tabRvcVoices: "🎙️ RVC Voices",
      tabCollaborators: "Collaborators Outreach",
      selectSection: "Select section",
      currentSection: "Active section",
      changeSection: "Change",
      closeSectionMenu: "Close"
    },
    users: {
      title: "CRM / Users",
      totalRegistered: "Total registered: {count}",
      searchPlaceholder: "Search by name, email, tax ID...",
      searchAriaLabel: "Search by name, email or tax ID",
      clearSearch: "Clear search",
      globalActions: "Global actions",
      enableAiNavAll: "Enable AI Navigation (all)",
      disableAiNavAll: "Disable AI Navigation (all)",
      tableScrollHint: "Scroll horizontally for more columns",
      tableScrollKeyboardHint: "Use left/right arrows to scroll",
      tableAriaLabel: "CRM Users Table",
      colUser: "User",
      colStatusContact: "Status & Contact",
      colDoctrineEditor: "Doctrine & Editor Access",
      colVoiceVideo: "AI Voice / Video",
      colAiNav: "AI Navigation & Professional",
      colCost: "AI Cost",
      colRole: "Access & Role",
      colRegistration: "Registration",
      colActions: "Actions",
      noPhone: "No phone",
      doctrineAccess: "Doctrine Access",
      doctrineActive: "Active",
      doctrineInactive: "Inactive",
      editorAccess: "Editor Access",
      editorActive: "Editor Active",
      editorInactive: "No Editor Access",
      voiceAndreea: "Andreea Voice",
      voiceStandard: "Standard",
      wav2lipVideo: "Wav2Lip Video Generation",
      aiNav: "AI Navigation",
      aiNavActive: "AI Navigation Active",
      aiNavManual: "Manual Mode",
      proMode: "Professional",
      proModeActive: "Professional",
      proModeInactive: "Non-professional",
      perMonth: "/ month",
      totalCalls: "{count} calls / month",
      viewDetails: "View full details",
      deleteUser: "Delete user",
      cardDetailsBtn: "Details & management",
      cardCollapseBtn: "Fewer details",
      sectionContact: "Contact & Tax Details",
      sectionPermissions: "Permissions & Access",
      sectionAiCosts: "AI Costs & Usage",
      sectionAdministration: "Account Administration",
      registeredOn: "Registered:",
      openFullFile: "Open full record",
      deleteAccount: "Permanently delete account",
      pageOf: "Page {page} of {total}",
      pricingTitle: "AI Cost Accounting & Pricing Configuration",
      refreshData: "Refresh data",
      savePricing: "Save pricing",
      inputPriceLabel: "Input / 1M tokens (USD)",
      outputPriceLabel: "Output / 1M tokens (USD)",
      cachedInputPriceLabel: "Cached input / 1M (USD)",
      adjustCachedPrice: "+ Adjust Cached input",
      pricingNote: "* Modified pricing applies exclusively to future calls. Ledger history remains immutable at the execution-time rate.",
      lastUpdated: "Last updated: {date} by {user}",
      bulkConfirmTitleEnable: "Confirm bulk AI Navigation activation",
      bulkConfirmTitleDisable: "Confirm bulk AI Navigation deactivation",
      bulkConfirmCancel: "Cancel",
      bulkConfirmBtn: "Confirm operation"
    },
    profile: {
      title: "Profile Information",
      avatarFallback: "User",
      roleAdmin: "Administrator",
      rolePro: "Pro User",
      roleBasic: "Basic User",
      emailLabel: "Email",
      authMethodLabel: "Authentication Method",
      authGoogle: "Connected with Google",
      authPassword: "Email and Password",
      registrationDateLabel: "Registration Date",
      mobileAccessTitle: "Mobile Application Access (Google Play)",
      mobileAccessDesc: "To be able to log in to the mobile application (Google Play version), you must set a password. You will use your current email address ({email}) along with this password. Google access on the web platform will continue to function normally.",
      setPasswordLabel: "Set a password for the mobile application",
      passwordMinLength: "At least 8 characters, including letters and numbers",
      passwordRequiredError: "Please enter a password.",
      passwordMinLengthError: "Password must contain at least 8 characters.",
      passwordSuccess: "Password was set successfully. You can now log in to the mobile application.",
      savePasswordBtn: "Save Password",
      deleteAccountBtn: "Delete Account",
      deleteAccountProgress: "Deleting...",
      deleteAccountError: "Could not delete account.",
      deleteAccountGenericError: "An error occurred while deleting your account. Please try again.",
      unsubscribeBtn: "Unsubscribe",
      logoutBtn: "Logout",
      deleteModalTitle: "Delete Account",
      deleteModalMessage: "Are you sure you want to delete your account? This action is irreversible and all your data will be lost.",
      deleteModalConfirm: "Delete Account",
      deleteModalCancel: "Cancel"
    },
    company: {
      title: "My Companies",
      subtitle: "Add your company details here to use on invoices.",
      addBtn: "Add company",
      loadError: "Could not load companies.",
      deleteError: "An error occurred while deleting the company: {message}",
      noCompaniesTitle: "You have not added any companies",
      noCompaniesDesc: "Buying for your business? No problem! Add the details here that will appear on your order invoice.",
      cardDeleteTitle: "Delete company",
      cardDeleteConfirmMsg: "Are you sure you want to delete this company?",
      cardDeleteConfirmBtn: "Delete",
      cardDeleteCancelBtn: "Cancel",
      modalTitle: "Add legal entity",
      modalSecDetails: "Company details",
      modalSecAddress: "Registered office",
      modalNameLabel: "Company name",
      modalNamePlaceholder: "e.g., Ionescu Law Firm",
      modalCuiLabel: "Unique Registration Code",
      modalCuiPlaceholder: "12345678",
      modalRegComLabel: "Registration Number in Trade Register",
      modalBancaLabel: "Bank",
      modalBancaPlaceholder: "e.g., Banca Transilvania",
      modalIbanLabel: "IBAN Account",
      modalIbanPlaceholder: "RO12 BTRL ...",
      modalCountyLabel: "County",
      modalCountyPlaceholder: "Search county...",
      modalLocalityLabel: "Locality",
      modalLocalityPlaceholder: "e.g., Sector 1",
      modalAddressLabel: "Address",
      modalAddressPlaceholder: "e.g., Street, number, block, entrance, floor, apartment",
      modalSaveBtn: "Save",
      modalSaveProgress: "Saving...",
      valNameRequired: "Company name is required.",
      valCuiInvalid: "Unique Registration Code (CUI) is not valid.",
      valIbanInvalid: "IBAN code is not valid. Please check format RO...",
      valCountyRequired: "County is required.",
      valYearInvalid: "Registration year is not valid.",
      valRegComInvalid: "Trade Register registration number is not valid.",
      valSaveError: "An error occurred while saving the company."
    },
    address: {
      title: "My Addresses",
      subtitle: "Manage delivery and billing addresses.",
      addBtn: "Add address",
      loadError: "Could not load addresses.",
      deleteError: "An error occurred while deleting the address.",
      noAddressesTitle: "You have not added any addresses",
      noAddressesDesc: "Save your addresses here to place orders faster.",
      cardEditBtn: "edit",
      cardDeleteBtn: "delete",
      cardDeleteConfirm: "Are you sure you want to delete this address?",
      modalTitleEdit: "Modify address",
      modalTitleAdd: "Add address",
      modalSecContact: "Contact person",
      modalSecAddress: "Delivery address",
      modalNameLabel: "Name",
      modalNamePlaceholder: "First Last Name",
      modalPhoneLabel: "Phone number",
      modalPhonePlaceholder: "07xxxxxxxx",
      modalCountyLabel: "COUNTY",
      modalCountyPlaceholder: "Search county...",
      modalLocalityLabel: "Locality",
      modalLocalityPlaceholder: "e.g., Sector 1",
      modalAddressLabel: "Address",
      modalAddressPlaceholder: "Street, Number, Block, Entrance etc.",
      modalSaveBtn: "Save",
      valPhoneInvalid: "Phone number is not valid. Use 07xxxxxxxx format.",
      valSaveError: "An error occurred while saving the address."
    },
    storage: {
      secBanner: "🔐 Military-grade Security & Decentralization",
      title: "Decentralized Storage & Absolute Privacy",
      desc: "By enabling Google Drive integration, your case files, contacts, and documents are stored privately in your personal cloud.",
      descHighlight: "Verdict Line / LegeaAplicată has ZERO access to your data, documents, or case files!",
      successDriveConnected: "Google Drive account successfully connected!",
      errorDriveFailed: "Google Drive connection failed.",
      successDriveDisconnected: "Google Drive account disconnected.",
      errorConnectFirst: "Please connect your Google Drive account first.",
      successMigration: "Your data has been successfully migrated to your secure Google Drive!",
      errorMigrationFailed: "Migration failed.",
      errorConfirmWord: "For reset, please type exactly 'CONFIRM' in the validation box.",
      successReset: "Storage mode has been reset back to Server.",
      errorResetFailed: "Reset failed.",
      secTitleSelect: "Select Data Storage Mode",
      serverTitle: "Secure Server",
      serverStatusActive: "Active",
      serverDesc: "Your CRM data is saved on secure Verdict Line central servers. Provides quick access and pre-configured multi-user automatic synchronization.",
      driveTitle: "Personal Google Drive",
      driveStatusActive: "Private Active",
      driveDesc: "Data is completely decentralized automatically. Only you hold physical control, files, and storage space, making it ideal for rigorous professional secrecy standards.",
      serverActionTitle: "Are you ready to switch to Decentralized Storage on Google Drive?",
      serverActionDesc: "This action will initiate a secure migration that copies your case files, legal structures, and clients to your private Google Drive folder, securing everything at the highest level. Your central server database will be safely decommissioned.",
      connectGoogleBtn: "Connect Google Account",
      disconnectGoogleBtn: "Disconnect Account",
      storageLabel: "Google Drive storage space:",
      storageUsage: "{percent}% used ({usage} / {limit})",
      migrateBtn: "Initiate Migration to Google Drive",
      migratingBtn: "Migrating data...",
      migrationProgressTitle: "Processing secure migration...",
      migrationStatusPreparing: "Preparing migration...",
      driveActiveTitle: "Google Drive Storage is Active & Secure",
      driveActiveDesc: "Your CRM and case file data are stored privately as securely encrypted documents in the root directory: Google Drive/LegeaAplicata_CRM. Sync happens locally directly from your browser. Verdict Line server has ZERO access to this data.",
      driveActiveWarning: "The simple toggle switch has been locked securely to prevent data destruction or loop creation that would block the connection. If you wish to return to the Server, use the section below.",
      showDangerZone: "Show Advanced Administration Zone (Server Return)",
      dangerZoneTitle: "Danger Zone: Reset to Server Storage",
      dangerZoneDesc: "Warning! Switching back to server is done without automatic data migration to prevent file collision and corruption. Data entered into Google Drive in the meantime will remain on Drive, but your account will connect back to frozen or empty server data.",
      dangerZoneConfirmLabel: "For validation, type exactly the word CONFIRM:",
      dangerZoneBtn: "Reset storage to Server mode",
      dangerZoneProgressBtn: "Resetting storage...",
      dangerZoneCancelBtn: "Cancel",
      benefitsTitle: "Benefits of Direct Integration with Google Ecosystem",
      benefitsDesc: "The smart interface connects directly from the browser to your personal or professional Google account, giving you total freedom and protection.",
      benefit1Title: "Total Decentralization (Google Drive)",
      benefit1Desc: "Data never leaves your ecosystem. It is stored as secure JSON files in your own Google Drive. If you withdraw your permission, you have full physical control over the entire archive.",
      benefit2Title: "Google Calendar Synchronization",
      benefit2Desc: "Every monitored legal deadline, calculated according to the Civil Procedure Code or added manually, is instantly sent to Google Calendar. You have mobile reminders and alerts in real time.",
      benefit3Title: "OAuth 2.0 Security",
      benefit3Desc: "The integration respects the official Google Identity standard. Your passwords never reach us. The connection is established via an access token stored locally and encrypted securely in your browser.",
      guideTitle: "How to Configure Google Integration?",
      guideDesc: "The process is simple, extremely transparent, and takes less than 2 minutes. Here are the exact steps you need to follow:",
      guide1Title: "Access the Storage Settings panel",
      guide1Desc: "Go to your editor or administrator account in the Data Storage & Cloud section. Here you will find the official API control panel.",
      guide2Title: "Authenticate via Google Identity",
      guide2Desc: "Press the 'Connect Google Account' button, select your preferred Google or Gmail account in the official window that opens, and validate the access permissions.",
      guide3Title: "Google API Activation (Important for initial steps)",
      guide3Desc: "Make sure Google Drive API and Google Calendar API are enabled in your Google Cloud Console. In case of error 403 API disabled, follow the instructions and console buttons below to enable directly:",
      guide4Title: "Automatic Sync Active!",
      guide4Desc: "All set! The application automatically creates the private directory LegeaAplicataCRM on Drive. All CRM case files and actions are synchronized in real time without third-party interfaces.",
      faqTitle: "Frequently Asked Questions (FAQ)",
      faqDesc: "Everything you need to know about data storage and secure synchronization with Google.",
      faqQ1: "Who has physical access to my case files stored on Google Drive?",
      faqA1: "Only you and the people you authorize inside the CRM (editors, administrators). The connection between your browser and the Google API server is made directly using your credentials, without the database ever passing through or being stored on the LegeaAplicată central server.",
      faqQ2: "Do I need to pay for an additional Google subscription?",
      faqA2: "No. The service uses the space offered free of charge by Google upon creating any standard Gmail account (15 GB). Files stored under structured format take up extremely little space (under a few megabytes for thousands of cases), so you will never need a special space upgrade.",
      faqQ3: "What happens if I lose my Editor or Admin status in LegeaAplicată?",
      faqA3: "To guarantee absolute data security of your cabinet, access to Google Drive storage and API connections is permitted exclusively to Administrator or Editor accounts. The moment your rights are withdrawn by the account owner, access is blocked instantly.",
      faqQ4: "Can I use synchronization with the calendar on my phone?",
      faqA4: "Yes, absolutely! Because deadlines are saved in the Google Calendar associated with your account, they will automatically appear on the native Google Calendar application on iOS (iPhone), iPad, or any Android device, accompanied by sound alerts and notifications."
    },
    subscription: {
      title: "Subscription Status",
      desc: "Information about your current plan.",
      errorPlansLoad: "Could not load plans.",
      errorCheckoutInit: "Error initiating payment.",
      errorCheckoutSession: "Could not generate payment session.",
      errorCancelSub: "Could not cancel subscription.",
      errorCancelSubGeneric: "An error occurred while canceling the subscription.",
      errorOpenPortal: "Could not open portal.",
      warningPastDueTitle: "Payment failed or is delayed.",
      warningPastDueDesc: "Your Premium access is at risk. Please update your payment method to avoid service suspension.",
      warningPastDueBtn: "Update Card Now",
      warningUnpaidTitle: "Subscription Suspended.",
      warningUnpaidDesc: "We could not process the payment for your subscription. Premium benefits are currently inactive.",
      warningUnpaidBtn: "Resolve Payment Issue",
      successCancel: "Subscription successfully canceled. Access remains active until expiration.",
      backBtn: "Back",
      checkoutTitle: "Finalize Payment - {planName}",
      plansBackBtn: "Back to Profile",
      plansTitle: "Choose Premium Plan",
      planPopularBadge: "POPULAR",
      statusLoading: "Loading status...",
      statusPlanType: "Subscription Type",
      statusCostLabel: "Monthly Cost",
      statusActiveDate: "Activation Date",
      statusNextPayment: "Next Payment",
      statusExpirationDate: "Expires On",
      statusUnlimited: "Unlimited",
      statusPaymentMethod: "Payment method: ",
      statusPaymentManual: "manual_grant",
      statusPaymentLegacy: "Legacy Platform Migration",
      infoTitleUpgrade: "Upgrade to Premium?",
      infoTitleActive: "Subscription Status",
      infoDescUpgrade: "Get unlimited access, advanced AI analysis, and priority support.",
      infoDescActive: "You benefit from all active PRO features.",
      infoDescStatus: "Verify your subscription status.",
      btnViewPlans: "See Premium Plans",
      btnManagePortal: "Manage Subscription & Payments (Stripe)",
      statusActiveBadge: "Active Subscription",
      btnUnsubscribe: "Unsubscribe",
      unsubscribeHint: "You can cancel anytime from your account or from the Stripe Portal.",
      scheduledCancelTitle: "Scheduled Cancellation",
      scheduledCancelDesc: "Access valid until {date}",
      footerSecurePay: "Secure Stripe Payment",
      modalCancelTitle: "Are you sure you want to cancel your subscription?",
      modalCancelMessage: "You will lose access to Premium benefits at the end of the current period. This action is irreversible after expiration.",
      modalCancelConfirm: "Yes, Cancel Subscription",
      modalCancelCancel: "No, Keep Subscription"
    },
    ecris: ecrisTranslations.en
  },
  fr: {
    page: {
      titleAdmin: "Configuration du Système",
      titleUser: "Mon Compte",
      subtitleAdmin: "Ajuster les paramètres et gérer les utilisateurs",
      subtitleUser: "Gérer les paramètres du compte et l'abonnement",
      backToHome: "Page d'accueil",
      back: "Retour",
      resetBtn: "Réinitialiser",
      resetConfirm: "Êtes-vous sûr de vouloir réinitialiser tous les paramètres aux valeurs par défaut ?",
      resetSuccess: "Les paramètres ont été réinitialisés aux valeurs par défaut.",
      resetError: "Erreur lors de la réinitialisation des paramètres.",
      exportMenuBtn: "Télécharger le menu XL",
      exportMenuProgress: "Exportation...",
      exportMenuSuccess: "Le menu a été exporté avec succès !",
      exportMenuError: "Erreur lors de l'exportation du menu.",
      refreshFiltersBtn: "Recharger les filtres",
      refreshFiltersProgress: "Rechargement...",
      refreshFiltersConfirm: "Êtes-vous sûr de vouloir recharger tous les filtres ? Ce processus peut prendre quelques secondes.",
      refreshFiltersSuccess: "Filtres rechargés avec succès ! Le regroupement des objets juridiques a été mis à jour.",
      refreshFiltersError: "Erreur lors du rechargement des filtres. Vérifiez la connexion au serveur.",
      saveBtn: "Enregistrer",
      saveProgress: "Enregistrement...",
      saveSuccess: "Les paramètres ont été enregistrés avec succès !",
      saveError: "Erreur lors de l'enregistrement des paramètres.",
      loadSettingsError: "Impossible de charger les paramètres. Vérifiez la connexion au serveur.",
      tabProfile: "Profil",
      tabCompanies: "Mes Entreprises",
      tabAddresses: "Mes Adresses",
      tabStorage: "Stockage de données & Cloud",
      tabSubscription: "Abonnement & Paiements",
      tabUsers: "Utilisateurs",
      tabImportCase: "📥 Importer un Cas",
      tabImportCaseBulk: "📚 Importer des Cas en Masse",
      tabVideoPresentation: "🎥 Présentation Vidéo",
      tabRvcVoices: "🎙️ Voix RVC",
      tabCollaborators: "Contact Collaborateurs",
      selectSection: "Sélectionner la section",
      currentSection: "Section active",
      changeSection: "Modifier",
      closeSectionMenu: "Fermer"
    },
    users: {
      title: "CRM / Utilisateurs",
      totalRegistered: "Total inscrits : {count}",
      searchPlaceholder: "Rechercher par nom, e-mail, identifiant fiscal...",
      searchAriaLabel: "Rechercher par nom, e-mail ou identifiant fiscal",
      clearSearch: "Effacer la recherche",
      globalActions: "Actions globales",
      enableAiNavAll: "Activer Navigation IA (tous)",
      disableAiNavAll: "Désactiver Navigation IA (tous)",
      tableScrollHint: "Faites défiler horizontalement pour plus de colonnes",
      tableScrollKeyboardHint: "Utilisez les flèches gauche/droite pour naviguer",
      tableAriaLabel: "Tableau des utilisateurs CRM",
      colUser: "Utilisateur",
      colStatusContact: "Statut & Contact",
      colDoctrineEditor: "Accès Doctrine & Éditeur",
      colVoiceVideo: "Voix IA / Vidéo",
      colAiNav: "Navigation IA & Professionnel",
      colCost: "Coût IA",
      colRole: "Accès & Rôle",
      colRegistration: "Inscription",
      colActions: "Actions",
      noPhone: "Sans téléphone",
      doctrineAccess: "Accès Doctrine",
      doctrineActive: "Activé",
      doctrineInactive: "Inactif",
      editorAccess: "Accès Éditeur",
      editorActive: "Éditeur Activé",
      editorInactive: "Sans accès Éditeur",
      voiceAndreea: "Voix Andreea",
      voiceStandard: "Standard",
      wav2lipVideo: "Génération vidéo Wav2Lip",
      aiNav: "Navigation IA",
      aiNavActive: "Navigation IA Active",
      aiNavManual: "Mode Manuel",
      proMode: "Professionnel",
      proModeActive: "Professionnel",
      proModeInactive: "Non-professionnel",
      perMonth: "/ mois",
      totalCalls: "{count} appels / mois",
      viewDetails: "Voir tous les détails",
      deleteUser: "Supprimer l'utilisateur",
      cardDetailsBtn: "Détails & gestion",
      cardCollapseBtn: "Moins de détails",
      sectionContact: "Contact & Données Fiscales",
      sectionPermissions: "Permissions & Accès",
      sectionAiCosts: "Coûts & Consommation IA",
      sectionAdministration: "Administration du Compte",
      registeredOn: "Inscrit le :",
      openFullFile: "Ouvrir la fiche complète",
      deleteAccount: "Supprimer le compte définitivement",
      pageOf: "Page {page} sur {total}",
      pricingTitle: "Comptabilité Coûts IA & Tarification",
      refreshData: "Actualiser les données",
      savePricing: "Enregistrer les tarifs",
      inputPriceLabel: "Input / 1M tokens (USD)",
      outputPriceLabel: "Output / 1M tokens (USD)",
      cachedInputPriceLabel: "Cached input / 1M (USD)",
      adjustCachedPrice: "+ Ajuster Cached input",
      pricingNote: "* Les tarifs modifiés s'appliquent exclusivement aux appels futurs. L'historique du ledger reste immuable au tarif au moment de l'exécution.",
      lastUpdated: "Dernière mise à jour : {date} par {user}",
      bulkConfirmTitleEnable: "Confirmation de l'activation en masse de Navigation IA",
      bulkConfirmTitleDisable: "Confirmation de la désactivation en masse de Navigation IA",
      bulkConfirmCancel: "Annuler",
      bulkConfirmBtn: "Confirmer l'opération"
    },
    profile: {
      title: "Informations sur le Profil",
      avatarFallback: "Utilisateur",
      roleAdmin: "Administrateur",
      rolePro: "Utilisateur Pro",
      roleBasic: "Utilisateur Basique",
      emailLabel: "E-mail",
      authMethodLabel: "Méthode d'authentification",
      authGoogle: "Connecté avec Google",
      authPassword: "E-mail et mot de passe",
      registrationDateLabel: "Date d'inscription",
      mobileAccessTitle: "Accès à l'application mobile (Google Play)",
      mobileAccessDesc: "Pour pouvoir vous connecter à l'application mobile (version Google Play), vous devez définir un mot de passe. Vous utiliserez votre adresse e-mail actuelle ({email}) avec ce mot de passe. L'accès Google sur la plateforme Web continuera de fonctionner normalement.",
      setPasswordLabel: "Définir un mot de passe pour l'application mobile",
      passwordMinLength: "Au moins 8 caractères, avec des lettres et des chiffres",
      passwordRequiredError: "Veuillez saisir un mot de passe.",
      passwordMinLengthError: "Le mot de passe doit contenir au moins 8 caractères.",
      passwordSuccess: "Le mot de passe a été défini avec succès. Vous pouvez maintenant vous connecter à l'application mobile.",
      savePasswordBtn: "Enregistrer le mot de passe",
      deleteAccountBtn: "Supprimer le compte",
      deleteAccountProgress: "Suppression...",
      deleteAccountError: "Impossible de supprimer le compte.",
      deleteAccountGenericError: "Une erreur est survenue lors de la suppression de votre compte. Veuillez réessayer.",
      unsubscribeBtn: "Se désabonner",
      logoutBtn: "Se déconnecter",
      deleteModalTitle: "Supprimer le compte",
      deleteModalMessage: "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible et toutes vos données seront perdues.",
      deleteModalConfirm: "Supprimer le compte",
      deleteModalCancel: "Annuler"
    },
    company: {
      title: "Mes Entreprises",
      subtitle: "Ajoutez les coordonnées de votre entreprise ici pour les utiliser sur les factures.",
      addBtn: "Ajouter une entreprise",
      loadError: "Impossible de charger les entreprises.",
      deleteError: "Une erreur est survenue lors de la suppression de l'entreprise : {message}",
      noCompaniesTitle: "Vous n'avez pas ajouté d'entreprises",
      noCompaniesDesc: "Vous achetez pour votre entreprise ? Pas de problème ! Ajoutez ici les coordonnées qui figureront sur votre facture de commande.",
      cardDeleteTitle: "Supprimer l'entreprise",
      cardDeleteConfirmMsg: "Êtes-vous sûr de vouloir supprimer cette entreprise ?",
      cardDeleteConfirmBtn: "Supprimer",
      cardDeleteCancelBtn: "Annuler",
      modalTitle: "Ajouter une personne morale",
      modalSecDetails: "Détails de l'entreprise",
      modalSecAddress: "Siège social",
      modalNameLabel: "Nom de l'entreprise",
      modalNamePlaceholder: "ex : Cabinet d'avocats Ionescu",
      modalCuiLabel: "Code d'enregistrement unique",
      modalCuiPlaceholder: "12345678",
      modalRegComLabel: "Numéro d'enregistrement au Registre du Commerce",
      modalBancaLabel: "Banque",
      modalBancaPlaceholder: "ex : Banca Transilvania",
      modalIbanLabel: "Compte IBAN",
      modalIbanPlaceholder: "RO12 BTRL ...",
      modalCountyLabel: "Département",
      modalCountyPlaceholder: "Rechercher le département...",
      modalLocalityLabel: "Localité",
      modalLocalityPlaceholder: "ex : Secteur 1",
      modalAddressLabel: "Adresse",
      modalAddressPlaceholder: "ex : Rue, numéro, bâtiment, entrée, étage, appartement",
      modalSaveBtn: "Enregistrer",
      modalSaveProgress: "Enregistrement...",
      valNameRequired: "Le nom de l'entreprise est obligatoire.",
      valCuiInvalid: "Le code d'enregistrement unique (CUI) n'est pas valide.",
      valIbanInvalid: "Le code IBAN n'est pas valide. Veuillez vérifier le format RO...",
      valCountyRequired: "Le département est obligatoire.",
      valYearInvalid: "L'année d'enregistrement n'est pas valide.",
      valRegComInvalid: "Le numéro d'enregistrement au Registre du Commerce n'est pas valide.",
      valSaveError: "Une erreur est survenue lors de l'enregistrement de l'entreprise."
    },
    address: {
      title: "Mes Adresses",
      subtitle: "Gérer les adresses de livraison et de facturation.",
      addBtn: "Ajouter une adresse",
      loadError: "Impossible de charger les adresses.",
      deleteError: "Une erreur est survenue lors de la suppression de l'adresse.",
      noAddressesTitle: "Vous n'avez pas ajouté d'adresses",
      noAddressesDesc: "Enregistrez vos adresses ici pour passer des commandes plus rapidement.",
      cardEditBtn: "modifier",
      cardDeleteBtn: "supprimer",
      cardDeleteConfirm: "Êtes-vous sûr de vouloir supprimer cette adresse ?",
      modalTitleEdit: "Modifier l'adresse",
      modalTitleAdd: "Ajouter une adresse",
      modalSecContact: "Personne de contact",
      modalSecAddress: "Adresse de livraison",
      modalNameLabel: "Nom",
      modalNamePlaceholder: "Prénom Nom",
      modalPhoneLabel: "Numéro de téléphone",
      modalPhonePlaceholder: "07xxxxxxxx",
      modalCountyLabel: "DÉPARTEMENT",
      modalCountyPlaceholder: "Rechercher le département...",
      modalLocalityLabel: "Localité",
      modalLocalityPlaceholder: "ex : Secteur 1",
      modalAddressLabel: "Adresse",
      modalAddressPlaceholder: "Rue, numéro, bâtiment, entrée etc.",
      modalSaveBtn: "Enregistrer",
      valPhoneInvalid: "Le numéro de téléphone n'est pas valide. Utilisez le format 07xxxxxxxx.",
      valSaveError: "Une erreur est survenue lors de l'enregistrement de l'adresse."
    },
    storage: {
      secBanner: "🔐 Sécurité de niveau militaire & Décentralisation",
      title: "Stockage décentralisé & Confidentialité absolue",
      desc: "En activant l'intégration avec votre compte Google Drive, vos dossiers, contacts et documents sont stockés de manière privée dans votre cloud personnel.",
      descHighlight: "Verdict Line / LegeaAplicată a un accès ZÉRO à vos données, documents ou dossiers !",
      successDriveConnected: "Compte Google Drive connecté avec succès !",
      errorDriveFailed: "Échec de la connexion Google Drive.",
      successDriveDisconnected: "Compte Google Drive déconnecté.",
      errorConnectFirst: "Veuillez d'abord connecter votre compte Google Drive.",
      successMigration: "Vos données ont été migrées avec succès vers votre Google Drive sécurisé !",
      errorMigrationFailed: "Échec de la migration.",
      errorConfirmWord: "Pour la réinitialisation, veuillez taper exactement 'CONFIRM' dans la case de validation.",
      successReset: "Le mode de stockage a été réinitialisé vers le Serveur.",
      errorResetFailed: "Échec de la réinitialisation.",
      secTitleSelect: "Sélectionnez le mode de stockage des données",
      serverTitle: "Serveur Sécurisé",
      serverStatusActive: "Actif",
      serverDesc: "Vos données CRM sont enregistrées sur les serveurs centraux sécurisés de Verdict Line. Fournit un accès rapide et une synchronisation automatique multi-utilisateur préconfigurée.",
      driveTitle: "Google Drive Personnel",
      driveStatusActive: "Privatif Actif",
      driveDesc: "Les données sont entièrement décentralisées de manière automatique. Vous seul détenez le contrôle physique, les fichiers et l'espace de stockage, ce qui est idéal pour les normes rigoureuses du secret professionnel.",
      serverActionTitle: "Êtes-vous prêt à passer au stockage décentralisé sur Google Drive ?",
      serverActionDesc: "Cette action va lancer une migration sécurisée qui copiera vos dossiers, structures juridiques et clients vers votre dossier privé Google Drive, en sécurisant tout au plus haut niveau. Votre base de données sur le serveur central sera désactivée en toute sécurité.",
      connectGoogleBtn: "Connecter le compte Google",
      disconnectGoogleBtn: "Déconnecter le Compte",
      storageLabel: "Espace de stockage Google Drive :",
      storageUsage: "{percent}% utilisé ({usage} / {limit})",
      migrateBtn: "Lancer la migration vers Google Drive",
      migratingBtn: "Migration des données...",
      migrationProgressTitle: "Traitement de la migration sécurisée...",
      migrationStatusPreparing: "Préparation de la migration...",
      driveActiveTitle: "Le stockage Google Drive est actif & sécurisé",
      driveActiveDesc: "Vos données CRM et vos dossiers sont enregistrés de manière privée sous forme de documents cryptés sécurisés dans le dossier racine : Google Drive/LegeaAplicata_CRM. La synchronisation s'effectue localement directement depuis votre navigateur. Le serveur Verdict Line a un accès ZÉRO à ces données.",
      driveActiveWarning: "Le bouton de bascule simple a été verrouillé de manière sécurisée pour éviter la destruction de données ou la création de boucles qui bloqueraient la connexion. Si vous souhaitez à tout prix revenir au Serveur, utilisez la zone ci-dessous.",
      showDangerZone: "Afficher la zone d'administration avancée (Retour au Serveur)",
      dangerZoneTitle: "Zone dangereuse : Réinitialisation au stockage Serveur",
      dangerZoneDesc: "Attention ! Le retour au serveur se fait sans migration automatique des données afin de prévenir les collisions de fichiers et leur corruption. Les données saisies sur Google Drive entre-temps resteront sur Drive, mais votre compte se connectera à nouveau aux données gelées ou vides du serveur.",
      dangerZoneConfirmLabel: "Pour validation, tapez exactement le mot CONFIRM :",
      dangerZoneBtn: "Réinitialiser le stockage en mode Serveur",
      dangerZoneProgressBtn: "Réinitialisation du stockage...",
      dangerZoneCancelBtn: "Annuler",
      benefitsTitle: "Avantages de l'intégration directe avec l'écosystème Google",
      benefitsDesc: "L'interface intelligente se connecte directement depuis le navigateur à votre compte Google personnel ou professionnel, vous offrant une liberté et une protection totales.",
      benefit1Title: "Décentralisation totale (Google Drive)",
      benefit1Desc: "Les données ne quittent pas votre écosystème. Elles sont stockées sous forme de fichiers JSON sécurisés dans votre propre Google Drive. Si vous retirez votre autorisation, vous disposez d'un contrôle physique complet sur l'ensemble de l'archive.",
      benefit2Title: "Synchronisation Google Calendar",
      benefit2Desc: "Chaque échéance judiciaire surveillée, calculée selon le Code de Procédure Civile ou ajoutée manuellement, est instantanément envoyée à Google Calendar. Vous disposez de rappels et d'alertes sur votre téléphone en temps réel.",
      benefit3Title: "Sécurité OAuth 2.0",
      benefit3Desc: "L'intégration respecte la norme officielle Google Identity. Vos mots de passe ne nous parviennent jamais. La connexion s'établit via un jeton d'accès stocké localement et chiffré en toute sécurité dans votre navigateur.",
      guideTitle: "Comment configurer l'intégration Google ?",
      guideDesc: "Le processus est simple, extrêmement transparent et prend moins de 2 minutes. Voici les étapes exactes à suivre :",
      guide1Title: "Accédez au panneau Paramètres de stockage",
      guide1Desc: "Allez sur votre compte éditeur ou administrateur dans la section Stockage de données & Cloud. Vous y trouverez le panneau de contrôle officiel de l'API.",
      guide2Title: "Authentifiez-vous via Google Identity",
      guide2Desc: "Appuyez sur le bouton « Connecter le compte Google », sélectionnez votre compte Google ou Gmail préféré dans la fenêtre officielle qui s'ouvre, et validez les autorisations d'accès.",
      guide3Title: "Activation de l'API Google (Important pour les premières étapes)",
      guide3Desc: "Assurez-ce que l'API Google Drive et l'API Google Calendar sont activées dans votre console Google Cloud. En cas d'erreur 403 API disabled, suivez les instructions et les boutons de la console ci-dessous pour les activer directement :",
      guide4Title: "Synchronisation automatique active !",
      guide4Desc: "C'est prêt ! L'application crée automatiquement le dossier privé LegeaAplicataCRM sur Drive. Tous les dossiers CRM et actions sont synchronisés en temps réel sans interface tierce.",
      faqTitle: "Foire Aux Questions (FAQ)",
      faqDesc: "Tout ce que vous devez savoir sur le stockage des données et la synchronisation sécurisée avec Google.",
      faqQ1: "Qui a accès physiquement à mes dossiers stockés sur Google Drive ?",
      faqA1: "Uniquement vous et les personnes que vous autorisez au sein du CRM (éditeurs, administrateurs). La connexion entre votre navigateur et le serveur de l'API Google se fait directement avec vos identifiants, sans que la base de données ne passe ou ne soit stockée sur le serveur central LegeaAplicată.",
      faqQ2: "Dois-je payer un abonnement Google supplémentaire ?",
      faqA2: "Non. Le service utilise l'espace offert gratuitement par Google lors de la création de tout compte Gmail standard (15 Go). Les dossiers stockés sous format structuré occupent un espace extrêmement restreint (moins de quelques mégaoctets pour des milliers de dossiers), vous n'aurez donc jamais besoin d'une mise à niveau de l'espace.",
      faqQ3: "Que se passe-t-il si je perds mon statut d'Éditeur ou d'Administrateur dans LegeaAplicată ?",
      faqA3: "Pour garantir la sécurité absolue des données de votre cabinet, l'accès au stockage Google Drive et aux connexions API est réservé exclusivement aux comptes d'Administrateur ou d'Éditeur. Dès que vos droits sont retirés par le propriétaire du compte, l'accès est bloqué instantanément.",
      faqQ4: "Puis-je utiliser la synchronisation avec le calendrier de mon téléphone ?",
      faqA4: "Oui, absolument ! Comme les échéances sont enregistrées dans le Google Calendar associé à votre compte, elles apparaîtront automatiquement sur l'application native Google Calendar sur iOS (iPhone), iPad ou tout appareil Android, accompagnées d'alertes sonores et de notifications."
    },
    subscription: {
      title: "Statut de l'Abonnement",
      desc: "Informations sur votre forfait actuel.",
      errorPlansLoad: "Impossible de charger les forfaits.",
      errorCheckoutInit: "Erreur lors de l'initiation du paiement.",
      errorCheckoutSession: "Impossible de générer la session de paiement.",
      errorCancelSub: "Impossible d'annuler l'abonnement.",
      errorCancelSubGeneric: "Une erreur est survenue lors de l'annulation de l'abonnement.",
      errorOpenPortal: "Impossible d'ouvrir le portail.",
      warningPastDueTitle: "Le paiement a échoué ou est en retard.",
      warningPastDueDesc: "Votre accès Premium est menacé. Veuillez mettre à jour votre mode de paiement pour éviter la suspension du service.",
      warningPastDueBtn: "Mettre à jour la carte maintenant",
      warningUnpaidTitle: "Abonament suspendat.",
      warningUnpaidDesc: "Nous n'avons pas pu traiter le paiement de votre abonnement. Les avantages Premium sont actuellement inactifs.",
      warningUnpaidBtn: "Résoudre le problème de paiement",
      successCancel: "Abonnement annulé avec succès. L'accès reste actif jusqu'à l'expiration.",
      backBtn: "Retour",
      checkoutTitle: "Finaliser le Paiement - {planName}",
      plansBackBtn: "Retour au Profil",
      plansTitle: "Choisissez le Forfait Premium",
      planPopularBadge: "POPULAIRE",
      statusLoading: "Chargement du statut...",
      statusPlanType: "Type d'Abonnement",
      statusCostLabel: "Coût Mensuel",
      statusActiveDate: "Date d'activation",
      statusNextPayment: "Prochain Paiement",
      statusExpirationDate: "Expire le",
      statusUnlimited: "Illimité",
      statusPaymentMethod: "Mode de paiement : ",
      statusPaymentManual: "manual_grant",
      statusPaymentLegacy: "Migration de l'Ancienne Plateforme",
      infoTitleUpgrade: "Passer au Premium ?",
      infoTitleActive: "Statut de l'Abonnement",
      infoDescUpgrade: "Bénéficiez d'un accès illimité, d'une analyse IA avancée et d'un support prioritaire.",
      infoDescActive: "Vous bénéficiez de toutes les fonctionnalités PRO actives.",
      infoDescStatus: "Vérifiez le statut de votre abonnement.",
      btnViewPlans: "Voir les forfaits Premium",
      btnManagePortal: "Gérer l'Abonnement & les Paiements (Stripe)",
      statusActiveBadge: "Abonnement Actif",
      btnUnsubscribe: "Se désabonner",
      unsubscribeHint: "Vous pouvez annuler à tout moment depuis votre compte ou depuis le portail Stripe.",
      scheduledCancelTitle: "Annulation Planifiée",
      scheduledCancelDesc: "Accès valide jusqu'au {date}",
      footerSecurePay: "Paiement Sécurisé Stripe",
      footerWarranty: "Garanție de 30 de zile",
      modalCancelTitle: "Êtes-vous sûr de vouloir annuler votre abonnement ?",
      modalCancelMessage: "Vous perdrez l'accès aux avantages Premium à la fin de la période en cours. Cette action est irréversible après l'expiration.",
      modalCancelConfirm: "Oui, Annuler l'Abonnement",
      modalCancelCancel: "Non, Conserver l'Abonnement"
    },
    ecris: ecrisTranslations.fr
  }
};

export default settingsTranslations;
